import {
    CREATE_USER_FORM_COLOR_MASTER,
    FETCH_COLOR_MASTER_FAILURE,
    FETCH_COLOR_MASTER_REQUEST,
    FETCH_COLOR_MASTER_SUCCESS,
    NAVIGATE_COLOR_DETAIL,
    RESET_USER_FORM_COLOR_MASTER,
    FETCH_SINGLE_COLOR_MASTER_REQUEST,
    FETCH_SINGLE_COLOR_MASTER_SUCCESS,
    FETCH_SINGLE_COLOR_MASTER_FAILURE,
    UPDATE_COLOR_MASTER_REQUEST,
    UPDATE_COLOR_MASTER_SUCCESS,
    CREATE_COLOR_MASTER_REQUEST,
    CREATE_COLOR_MASTER_SUCCESS,
    CREATE_COLOR_MASTER_FAILURE,
    UPDATE_COLOR_MASTER_FAILURE,
    NAVIGATE_COLOR_MASTER,
    DELETE_COLOR_MASTER_REQUEST,
    DELETE_COLOR_MASTER_SUCCESS,
    DELETE_COLOR_MASTER_FAILURE
} from './colorMaster.actionsType';

export const COLOR_MASTER = 'colorMaster';

let initialState = {
    loading: false,
    colorMaster: [],
    userform: {},
    selectedColor: {},
    isColorDetail: false,
    errorMessage: '',
    colorInfo: {},
    iperrorMessage: ''
};

export let colorReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_COLOR_MASTER_REQUEST:
        case CREATE_COLOR_MASTER_REQUEST:
        case FETCH_SINGLE_COLOR_MASTER_REQUEST:
        case UPDATE_COLOR_MASTER_REQUEST:
        case DELETE_COLOR_MASTER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_COLOR_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                colorMaster: updatePayload
            };
        case CREATE_COLOR_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {}
            };
        case FETCH_SINGLE_COLOR_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedColor: updatePayload,
                userform: { code: updatePayload.fldCode, color: updatePayload.fldDescription }
            };
        case UPDATE_COLOR_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {}
            };
        case DELETE_COLOR_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {},
                selectedColor: null
            };
        case FETCH_COLOR_MASTER_FAILURE:
        case CREATE_COLOR_MASTER_FAILURE:
        case FETCH_SINGLE_COLOR_MASTER_FAILURE:
        case UPDATE_COLOR_MASTER_FAILURE:
        case DELETE_COLOR_MASTER_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_COLOR_MASTER:
            return {
                ...state,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case RESET_USER_FORM_COLOR_MASTER:
            return {
                ...state,
                userform: {},
                selectedColor: {}
            };
        case NAVIGATE_COLOR_DETAIL:
            return {
                ...state,
                isColorDetail: true,
                colorInfo: updatePayload
            };
        case NAVIGATE_COLOR_MASTER:
            return {
                ...state,
                isColorDetail: false
            };
        default:
            return state;
    }
};
